import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Emails from '../../constants/Emails';
import { Card, HeadingFour, Paragraph, Container, Row, Col } from 'hui';

export default class AppErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.node
  };

  state = {
    error: false
  };

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
  }

  render() {
    const { children } = this.props;
    const { error, errorInfo } = this.state;

    if (!error) {
      return children;
    }

    return (
      <Container>
        <Row>
          <Col xs={12} mb={1}>
            <Card white>
              <HeadingFour tag="span">{`Oh no! Something went wrong...`}</HeadingFour>
              <Paragraph>
                Sorry about that, our tech team has been alerted to this issue and will be on it
                soon as possible.
              </Paragraph>
              <Paragraph tag="div">
                Meanwhile, you can try one of the following:
                <ul>
                  <li>Click your browsers refresh button</li>
                  <li>
                    If you would like to enquire about this, please{' '}
                    <a href={`mailto:${Emails.SUPPORT}`}>email</a> us and we will investigate
                    further
                  </li>
                  <li>
                    Click here to go to the <a href="/">homepage</a>.
                  </li>
                </ul>
              </Paragraph>
            </Card>
            <Card>
              {process.env.NODE_ENV === 'development' && (
                <div>
                  <p>
                    <strong>Oops! An error occured!</strong>
                  </p>
                  <p>Here’s what we know…</p>
                  <p>
                    <strong>Error:</strong> <pre>{error.toString()}</pre>
                  </p>
                  <p>
                    <strong>Stacktrace:</strong> <pre>{errorInfo.componentStack}</pre>
                  </p>
                </div>
              )}
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}
